import utilities from './utilities'
import initApi from './init-api'

export default { utilities, initApi }
